import {
  ComponentBuilder,
  FunctionComponent
} from '../../component-builder/types';
import { DisplayConfigType } from 'formats/display/lib/config';
import { Component } from './component';

export class CtaBuilder implements ComponentBuilder<DisplayConfigType> {
  isInjectable(adContext: AdContext, formatConfig: DisplayConfigType): boolean {
    return formatConfig?.cta?.useCta;
  }

  build(
    adContext: AdContext,
    formatConfig: DisplayConfigType
  ): FunctionComponent {
    return Component;
  }
}
